import { useQuery } from '@tanstack/react-query';

import bundlesService from '~/services/cruises/BundlesService';

import { bundleQueryKeys } from './bundleQueryKeys';

export function useGetBundleItems(bundleId: string) {
  return useQuery({
    queryKey: bundleQueryKeys.items(bundleId),
    queryFn: async () => {
      const response = await bundlesService.getItems(bundleId);
      return response.result;
    },
    enabled: !!bundleId,
  });
}
